module.exports = __webpack_public_path__ + "static/media/11.ef1f82f7.png";